module.exports = __webpack_public_path__ + "img/basket3-fill.9c8a3995.svg";